export const STORAGE_KEYS = {
    STEP_1: 'createJobStep1',
    STEP_2: 'createJobStep2',
    STEP_3: 'createJobStep3',
    STEP_4: 'createJobStep4',
    CURRENT_STEP: 'createJobCurrentStep'
  };